import admin from "./admin.jpg";
import command from "./command.jpg";
import examer from "./examer.jpg";
import examiner from "./examiner.jpg";
import coordinator from "./coordinator.jpg";

const images = {
    admin, command, examer, examiner, coordinator
}

export default images;